import { icon } from "../functions/icons";
import { ButtonGroup, DropdownButton, StandardButton } from "./buttons";

export function PresentationButton({typeButton, textColor = "black", backgroundColor = "white", onClick}){
    return(
        <StandardButton
            onClick={onClick}
            textColor={textColor}
            backgroundColor={backgroundColor}
            title={
                icon(typeButton)
            }
        />
    )
}

export function FilterButton({setFilter}) {
    // var filteroptions = [{"id": "NameAsc", "content": "Naam (Alfabetisch)", sele}, {"id": "NameDesc", "content": "Naam (Onalfabetisch)"}, {"id": "CursistsAsc", "content": "Aantal cursisten (oplopend)"}, {"id": "CursistsDesc", "content": "Aantal cursisten (aflopend)"}, {"id": "TimeAsc", "content": "Tijd (oplopend)"}, {"id": "TimeDesc", "content": "Tijd (aflopend)"}]
    return (
        <DropdownButton
            content={<>{icon("filter")}&nbsp;&nbsp;{"sorteren"}</>}
            dropdown={[{"id": "NameAsc", "content": "Naam (Alfabetisch)", "selected": true}, {"id": "NameDesc", "content": "Naam (Onalfabetisch)"}, {"id": "CursistsAsc", "content": "Aantal cursisten (oplopend)"}, {"id": "CursistsDesc", "content": "Aantal cursisten (aflopend)"}, {"id": "TimeAsc", "content": "Tijd (oplopend)"}, {"id": "TimeDesc", "content": "Tijd (aflopend)"}]}
            optionSelected={(a) => console.log(a)}
        />
    )
}

export function LayoutButton({gridViewFunction, listViewFunction, currentPresentation}) {
    var buttons = [
        {
            "onClick": gridViewFunction,
            "id": 2,
            "content": icon("layout-grid"),
        },
        {
            "onClick": listViewFunction,
            "id": 1,
            "content": icon("list")
        }
    ]
    
    buttons[buttons.map(c => c.id).indexOf(currentPresentation)].selected = true

    return (
        <>
            <ButtonGroup buttons={buttons}/>
        </>
        
        // <>
        //     <StandardButton
        //         onClick={gridViewFunction}
        //         textColor="var(--black)"
        //         backgroundColor="var(--white)"
        //         title={
        //             icon("layout-grid")
        //         }
        //     />
        //     <StandardButton
        //         onClick={listViewFunction}
        //         textColor="var(--black)"
        //         backgroundColor="var(--white)"
        //         title={
        //             icon("list")
        //         }
        //     />
        // </>
    )
}